import { render, staticRenderFns } from "./InspectionSamplingReport.vue?vue&type=template&id=54a54ca4&scoped=true"
import script from "./InspectionSamplingReport.vue?vue&type=script&lang=ts"
export * from "./InspectionSamplingReport.vue?vue&type=script&lang=ts"
import style0 from "./InspectionSamplingReport.vue?vue&type=style&index=0&id=54a54ca4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a54ca4",
  null
  
)

export default component.exports